import React from 'react';
import PropTypes from 'prop-types';
import mapIcons from 'assets/map/drawing.png';
import './terra-draw-controls.scss';

export const MODES = {
    SELECT: 'select',
    RECTANGLE: 'rectangle',
};

const ControlButton = ({ mode, currentMode, icon, onClick, disabled }) => (
    <button
        type="button"
        className={`terra-btn ${currentMode === mode ? 'active' : ''}`}
        disabled={disabled}
        onClick={onClick}
    >
        <span>
            <div className="img-wrapper">
                <img
                    alt=""
                    src={mapIcons}
                    draggable="false"
                    className={icon}
                />
            </div>
        </span>
    </button>
);

ControlButton.propTypes = {
    mode: PropTypes.string.isRequired,
    currentMode: PropTypes.string,
    icon: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
};

export default function TerraDrawControls({ draw, currentMode, onModeChange }) {
    const handleModeChange = (mode) => {
        draw?.setMode?.(mode);
        onModeChange?.(mode);
    };

    return (
        <div className="terra-draw-controls">
            <ControlButton
                mode={MODES.SELECT}
                currentMode={currentMode}
                icon="img-pan"
                onClick={() => handleModeChange(MODES.SELECT)}
                disabled={!draw}
            />
            <ControlButton
                mode={MODES.RECTANGLE}
                currentMode={currentMode}
                icon="img-select"
                onClick={() => handleModeChange(MODES.RECTANGLE)}
                disabled={!draw}
            />
        </div>
    );
}

TerraDrawControls.propTypes = {
    draw: PropTypes.object,
    currentMode: PropTypes.string,
    onModeChange: PropTypes.func,
};
